import { ArrowRight, CheckCircle, Text } from '@doda/io-react/common';
import { createCompanyPageLinkName } from '@doda/common/src/logics/jobSearchDetail/createCompanyPageLinkName';
import { measureClickCompanyPageLinkBanner } from 'pages/DodaFront/View/JobSearchDetail/logics/analytics';
import { useAppDispatch, useAppSelector } from '@doda/pc/src/redux/hooks';
import { adobeAnalyticsScriptsSelector } from '@doda/common/src/redux/features/analytics';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import styles from './index.module.scss';

/**
 * CompanyPageLinkBannerのProps
 */
interface Props {
  companyId: string;
  corporateName: string;
  jid: string;
  hasArticleContent: boolean;
}

/**
 * 企業についてもっと詳しく知りたい方はこちらバナー
 */
export const CompanyPageLinkBanner: React.FC<Props> = ({
  companyId,
  corporateName,
  jid,
  hasArticleContent,
}) => {
  const dispatch = useAppDispatch();
  const isAdobeScript = useAppSelector(adobeAnalyticsScriptsSelector);
  const url = `/DodaFront/View/Company/j_id__${companyId}/`;
  const { companyPageLinkName } = createCompanyPageLinkName(corporateName);
  const appQueryParams = useAppSelector(appQueryParamsSelector);
  const { message_id, scoutlist_id, osscfl, wlstid } = appQueryParams;
  return (
    <a
      href={url}
      onClick={(event) =>
        measureClickCompanyPageLinkBanner(
          isAdobeScript,
          dispatch,
          jid,
          event,
          url,
          message_id,
          scoutlist_id,
          osscfl,
          wlstid,
          hasArticleContent
        )
      }
      className={styles['jobSearchDetail-companyPageLinkBanner']}
      target="_blank"
      rel="noopener"
    >
      <div
        className={
          styles['jobSearchDetail-companyPageLinkBanner__titleWrapper']
        }
      >
        <Text color="white" weight="bold">
          {companyPageLinkName} について
        </Text>
        <Text size="20" color="white" weight="bold">
          もっと詳しく知りたい方はこちら
        </Text>
      </div>
      <div className={styles['jobSearchDetail-companyPageLinkBanner__right']}>
        <div
          className={
            styles['jobSearchDetail-companyPageLinkBanner__listWrapper']
          }
        >
          <ul className={styles['jobSearchDetail-companyPageLinkBanner__list']}>
            {ITEM_LIST.map((text) => (
              <li
                key={text}
                className={
                  styles['jobSearchDetail-companyPageLinkBanner__listItem']
                }
              >
                <CheckCircle color="blue" size="M" />
                <Text weight="bold">{text}</Text>
              </li>
            ))}
          </ul>
          <Text weight="bold">など...</Text>
        </div>
        <Text size="10" color="gray">
          ※表示される内容は企業ごとに異なります。
        </Text>
      </div>
      <div className={styles['jobSearchDetail-companyPageLinkBanner__arrow']}>
        <ArrowRight color="white" size="M" />
      </div>
    </a>
  );
};

const ITEM_LIST = [
  '平均年収',
  '勤続年数',
  '平均年齢',
  '売上高',
  '経常利益',
  '業界情報',
];
